/**
 * Embed-host helpers.
 *
 * `checkout.lumiari.ai` ships `frame-ancestors 'self' https://*.lumiari.ai`,
 * so the checkout iframe only renders when the widget is embedded on a
 * `*.lumiari.ai` page (or on localhost for development). On any other host
 * the browser blocks the frame, so the widget opens the checkout in a new tab.
 */

/** Production API used when `init({ apiUrl })` is not provided. */
export const DEFAULT_API_URL = 'https://agent-api.lumiari.ai';

/** True when the checkout iframe is allowed to render on `hostname`. */
export function canFrameCheckout(hostname: string): boolean {
  const host = String(hostname || '').trim().toLowerCase().replace(/\.$/, '');
  if (!host) return false;
  if (host === 'localhost' || host === '127.0.0.1' || host === '[::1]' || host === '::1') {
    return true;
  }
  return host.endsWith('.lumiari.ai');
}

/** How the checkout should be presented on the current page. */
export function checkoutPresentation(hostname: string): 'iframe' | 'tab' {
  return canFrameCheckout(hostname) ? 'iframe' : 'tab';
}

/** Hostname of the page embedding the widget (seam kept separate for tests). */
export function getEmbedHostname(): string {
  return typeof window !== 'undefined' && window.location ? window.location.hostname || '' : '';
}
